import {CONSTANTS} from '@/constants';
import { functions } from '@/functions';
import miniToastr from "mini-toastr";

/*
 *  Брони
 */

export const functions_booking = {

    data: function () {
        return {
            booking:null,
            bookings:[],
            bookings_loaded:false,
        };
    },

    computed: {
        // is_customer_loaded: function () {
        //     return this.isCustomerLoaded();
        // },
        // is_customers_loaded: function () {
        //     return this.isCustomersLoaded();
        // },
    },

    methods: {
        getBookingStatusNameAgent: function (status) {
            switch(status) {
                case 0: return 'Черновик';
                case 1: return 'Запрос';
                case 2: return 'Забронировано';
                case 3: return 'Оплачено';
                case 4: return 'Оплачено';
                case 5: return 'Отменено';
                case 6: return 'Архив';
                default: return 'Иное';
            }
        },

        getBookingStatusName: function (status) {
            switch(status) {
                case 0: return 'Черновик';
                case 1: return 'Запрос';
                case 2: return 'Забронировано';
                case 3: return 'Выкуплено';
                case 4: return 'Оплачено';
                case 5: return 'Отменено';
                case 6: return 'Архив';
                default: return 'Иное';
            }
        },


        loadBookingsForVoucher: function (voucher_id, onSuccess=null, param=null) {
            if (!this.isBookingsLoaded() && voucher_id) {
                this.bookings = [];
                this.httpPrepare();
                this.$http.get(this.apiurl('voucher/' + voucher_id + '/bookings')).then(function (response) {
                    response = this.httpSuccess(response);
                    this.bookings = response.payload;
                    this.executeFunction(onSuccess, param);
                }, function (error) {
                    this.error_log(error);
                })
            }
            return this;
        },


        loadBookingsForCompany: function (company_id, onSuccess=null, param=null) {
            if (company_id) {
                this.bookings = [];
                this.httpPrepare();
                self = this;
                this.$http.get(this.apiurl('booking/unbinded/' + company_id )).then(function (response) {
                    response = self.httpSuccess(response);
                    self.bookings = response.payload;
                    self.executeFunction(onSuccess, param);
                }, function (error) {
                    self.error_log(error);
                })
            }
            return this;
        },

        resetBookings: function () {
            this.bookings = [];
            return this;
        },

        isBookingsLoaded: function () {
            return (this.bookings !== null) && this.bookings.length;
        },

        /*
         *  Бронь
         */

        loadBooking: function (booking_id, onSuccess=null, param=null) {
            console.log('loadBooking[1]=',booking_id)
            if (!this.isBookingLoaded() && booking_id) {
                console.log('loadBooking[2]=',booking_id)
                this.booking = null;
                this.httpPrepare();
                this.$http.get(this.apiurl('booking/' + booking_id )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.booking = response.payload;
                    this.executeFunction(onSuccess, param, response.payload);
                }, this.httpError)
            }
            return this;
        },

        isBookingLoaded: function () {
            return (this.booking !== null) && this.booking;
        },

        resetBooking: function () {
            this.booking = null;
            return this;
        },

        cancelBooking: function (booking_id, onSuccess=null, param=null) {
            if (booking_id) {
                let safe_booking = this.booking;
                this.booking = null;
                let self = this;
                this.httpPrepare();
                this.$http.delete(this.apiurl('booking/' + booking_id + '/cancel' )).then(function (response) {
                    response = this.httpSuccess(response);
                    self.booking = response.payload;
                    this.executeFunction(onSuccess, param);
                }, function (error) {
                    self.booking = safe_booking;
                    this.httpError(error);
                })
            }
            return this;
        },

        agencyPayBooking: function (booking_id, onSuccess=null, param=null) {
            if (booking_id) {
                let safe_booking = this.booking;
                this.booking = null;
                let self = this;
                this.httpPrepare();
                this.$http.put(this.apiurl('booking/' + booking_id + '/agpay' )).then(function (response) {
                    response = this.httpSuccess(response);
                    self.booking = response.payload;
                    this.executeFunction(onSuccess, param);
                }, function (error) {
                    self.booking = safe_booking;
                    this.httpError(error);
                })
            }
            return this;
        },

        systemPayBooking: function (booking_id, onSuccess=null, param=null) {
            if (booking_id) {
                let safe_booking = this.booking;
                this.booking = null;
                let self = this;
                this.httpPrepare();
                this.$http.put(this.apiurl('booking/' + booking_id + '/syspay' )).then(function (response) {
                    response = this.httpSuccess(response);
                    self.booking = response.payload;
                    this.executeFunction(onSuccess, param);
                }, function (error) {
                    self.booking = safe_booking;
                    this.httpError(error);
                })
            }
            return this;
        },

        correctBooking: function (booking_id, total, agfee, sysfee, onSuccess=null, param=null) {
            if (booking_id) {
                let safe_booking = this.booking;
                this.booking = null;
                let self = this;
                this.httpPrepare();
                this.$http.put(this.apiurl('booking/' + booking_id + '/correct' )).then(function (response) {
                    response = this.httpSuccess(response);
                    self.booking = response.payload;
                    this.executeFunction(onSuccess, param);
                }, function (error) {
                    self.booking = safe_booking;
                    this.httpError(error);
                })
            }
            return this;
        },

        finishBooking: function (booking_id, total= null, agfee= null, sysfee= null, onSuccess=null, param=null) {
            if (booking_id) {
                let safe_booking = this.booking;
                this.booking = null;
                let self = this;
                this.httpPrepare();
                this.$http.put(this.apiurl('booking/' + booking_id + '/opfinish' )).then(function (response) {
                    response = this.httpSuccess(response);
                    self.booking = response.payload;
                    this.executeFunction(onSuccess, param);
                }, function (error) {
                    self.booking = safe_booking;
                    this.httpError(error);
                })
            }
            return this;
        },



        updateBookingEx: function (booking_id, onSuccess=null, param=null) {
            console.log("updateBookingEx 1 booking_id=" + booking_id);
            if (booking_id) {
                console.log("updateBookingEx 2");
                this.booking = null;
                this.httpPrepare();
                this.$http.put(this.apiurl('booking/' + booking_id + '/ex-update' )).then(function (response) {
                    response = this.httpSuccess(response);
                    this.booking = response.payload;
                    this.executeFunction(onSuccess, param);
                }, this.httpError)
            }
            return this;
        },

        cancelBookingEx: function (booking_id, onSuccess=null, onError=null, param=null) {
            if (booking_id) {
                let self = this;
                this.booking = null;
                this.httpPrepare();
                this.$http.put(this.apiurl('booking/' + booking_id + '/ex-cancel' )).then(function (response) {
                    response = this.httpSuccess(response);
                    self.booking = response.payload;
                    if (response.result==='success') {
                        miniToastr["success"]('Отмена выполнена', null, CONSTANTS.TOAST_SUCCESS_LIFETIME);
                        this.executeFunction(onSuccess, param);
                    }
                    else {
                        miniToastr["error"]('При выполнении отмены произошла ошибка: ' + response.error, null, CONSTANTS.TOAST_ERROR_LIFETIME);
                        this.executeFunction(onError, param);
                    }
                }, function (error) {
                    this.httpError(error);
                    this.executeFunction(onError, param);
                })
            }
            return this;
        },

        payBookingEx: function (booking_id, onSuccess=null, onError=null, param=null) {
            if (booking_id) {
                let self = this;
                this.httpPrepare();
                this.$http.put(this.apiurl('booking/' + booking_id + '/ex-pay' )).then(function (response) {
                    response = this.httpSuccess(response);
                    self.booking = response.payload;
                    if (response.result==='success') {
                        miniToastr["success"]('Оплата выполнена', null, CONSTANTS.TOAST_SUCCESS_LIFETIME);
                        this.executeFunction(onSuccess, param);
                    }
                    else {
                        miniToastr["error"]('При выполнении оплаты произошла ошибка: ' + response.error, null, CONSTANTS.TOAST_ERROR_LIFETIME);
                        this.executeFunction(onError, param);
                    }
                }, function (error) {
                    this.httpError(error);
                    this.executeFunction(onError, param);
                })
            }
            return this;
        },


        can_be_payed_by_agency: function(booking) {
            if (!booking.supplier_id) {
                return false;
            }

            // TODO это временно
            // return booking.status == CONSTANTS.BOOKING_STATUS_BOOKED;
            return false;
        },

        can_be_payed_by_system: function(booking) {
            if (!booking.supplier_id) {
                return false;
            }

            // TODO это временно
            // return booking.status == TANTS.BOOKING_S.BOOKING_STATUS_PAYED;
            return booking.status === CONSTANTS.BOOKING_STATUS_BOOKED;
        },

        can_be_cancelled: function (booking) {
            if (!booking.supplier_id) {
                return false;
            }
            switch(booking.status) {
                case CONSTANTS.BOOKING_STATUS_DRAFT:
                case CONSTANTS.BOOKING_STATUS_REQUEST:
                case CONSTANTS.BOOKING_STATUS_BOOKED:
                case CONSTANTS.BOOKING_STATUS_PAYED:
                case CONSTANTS.BOOKING_STATUS_SOLD:
                    return true;
                case CONSTANTS.BOOKING_STATUS_CANCELLED:
                case CONSTANTS.BOOKING_STATUS_CLOSED:
                default:
                    return false;
            }
        },

        can_be_finished: function (booking) {
            if (!booking.supplier_id) {
                return false;
            }
            switch(booking.status) {
                case CONSTANTS.BOOKING_STATUS_BOOKED:
                case CONSTANTS.BOOKING_STATUS_SOLD:
                    return true;
                default:
                    return false;
            }
        },

        can_be_corrected: function (booking) {
            if (!booking.supplier_id) {
                return false;
            }
            switch(booking.status) {
                case CONSTANTS.BOOKING_STATUS_CLOSED:
                    return true;
                default:
                    return false;
            }
        },

        can_be_operated: function(booking) {
            switch(booking.status) {
                case CONSTANTS.BOOKING_STATUS_REQUEST:
                case CONSTANTS.BOOKING_STATUS_BOOKED:
                case CONSTANTS.BOOKING_STATUS_PAYED:
                case CONSTANTS.BOOKING_STATUS_SOLD:
                case CONSTANTS.BOOKING_STATUS_CLOSED:
                    return true;
                default:
                    return false;
            }
        },

        can_be_edited: function(booking) {
            switch(booking.status) {
                case CONSTANTS.BOOKING_STATUS_DRAFT:
                case CONSTANTS.BOOKING_STATUS_REQUEST:
                case CONSTANTS.BOOKING_STATUS_BOOKED:
                    return true;
                default:
                    return false;
            }
        },

        booking_status_name: function (booking) {
            return CONSTANTS.BOOKING_STATUS_NAMES_DICT[booking.status]
        },

    },
};

